import Text from './Text/Text';
import Select from './Select/Select';
import Search from './Search/Search';
import ModelPortfolioSearch from './Search/ModelPortfolioSearch';
import Checkbox from './Checkbox/Checkbox';
import Validators from './Validators/Validators';
import String from './String/String';
import SwitchPoundPercantage from './SwitchPoundPercantage/SwitchPoundPercantage';
import Warn from './Warn/Warn';
import WrapCash from './WrapCash/WrapCash';
import CheckboxCustom from './CheckboxCustom/CheckboxCustom';
import SearchGeneric from './Search/SearchGeneric';
import { v2 } from './v2';
import SelectAuto from './SelectAuto/SelectAuto';

export default {
  Text,
  Select,
  Validators,
  Search,
  ModelPortfolioSearch,
  Checkbox,
  String,
  SwitchPoundPercantage,
  Warn,
  WrapCash,
  CheckboxCustom,
  SearchGeneric,
  SelectAuto,
  v2
};
